import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const clientApiUrl = process.env.REACT_APP_CLIENT_API_URL;

const CustomFieldAPI = {
	getCustomField: (organizationId: number, customFieldId: number) => {
		return axios
			.get(
				`${apiUrl}/organizations/${organizationId}/custom-fields/${customFieldId}`
			)
			.then((response) => response.data as CustomFieldDTO);
	},
	getCustomFields: (organization: CustomFieldsRequest) => {
		return axios
			.get(
				`${apiUrl}/organizations/${organization.organizationId!}/custom-fields`
			)
			.then((response) => response.data as CustomFieldDTO[]);
	},
	updateCustomField: (
		organizationId: number,
		customField: CustomFieldUpsertRequest
	) => {
		return axios
			.post(
				`${apiUrl}/organizations/${organizationId}/custom-fields`,
				customField
			)
			.then((response) => response.data as CustomFieldDTO);
	},

	updateCustomFieldOrder: ({
		organizationId,
		customFieldIds,
		orderList,
	}: CustomFieldOrderUpsertRequest) => {
		return axios.post(
			`${apiUrl}/organizations/${organizationId}/custom-fields-order`,
			{
				customFieldIds,
				orderList,
			}
		);
	},

	// client site methods
	getOrganizationCustomFields: (organizationId: number, datasetId: number) => {
		return axios
			.get(
				`${clientApiUrl}/organizations/${organizationId}/dataset/${datasetId}/customFields`
			)
			.then((response) => response.data as CustomFieldDTO[]);
	},
	getClientSiteCustomFieldValues: (
		request: GetClientSiteCustomFieldValuesRequest
	) => {
		return axios
			.get(
				`${clientApiUrl}/dataset/${request.datasetId}/custom-field-values/${request.customFieldValueType}/${request.customFieldValueId}`
			)
			.then((response) => response.data as CustomFieldValueDTO[]);
	},
	getClientSiteCustomFieldValue: (
		request: ClientSiteCustomFieldValuesRequest
	) => {
		return axios
			.post(
				`${clientApiUrl}/organizations/${request.organizationId}/dataset/
				${request.datasetId}/custom-field-values/${request.customFieldTypeId}/${request.customFieldIds}`
			)
			.then((response) => response.data as CustomFieldValueDTO[]);
	},
	deleteCustomFieldValues: (
		request: ClientSiteCustomFieldValuesDeleteRequest
	) => {
		return axios
			.delete(
				`${clientApiUrl}/custom-field-values/${request.customFieldValueIds}`
			)
			.then((response) => response.data as boolean);
	},
};

export default CustomFieldAPI;
